// TODO find somewhere better to put this

import {
  BadClickType,
  AnalysisMode,
  Opportunity,
  Signal,
} from '@fullstory/proto/fs/services/alexa';
import { DateRangeID, Flags } from '@fullstory/client-api';
import { isEmpty } from 'lodash';
import {
  OpportunitySnapshot,
  CreateOpportunitySnapshotRequest,
} from '@fullstory/proto/fs/services/webber/internal/impacts';
import { FsEvent } from '@fullstory/fs-script-api';
import { Funnel, Segment } from '@fullstory/proto/fs/services/search-settings';
import {
  BehaviorSignalElementBlock,
  BehaviorSignalType,
} from '@fullstory/proto/fs/services/ingestion-settings';
import { CurrencyFromCurrencyType, OpportunitiesWithID, RevenueEventForm } from './types';
import { signalTypeName } from './util';

// TODO(tim): find a better home for this
export interface GenerateOpportunityRequestAnalytics {
  requestId: string;
  segmentId: string;
  conversionFunnelId: string;
  segmentCriteriaHash: string;
  conversionCriteriaHash: string;
  conversionFunnelLength: number;
  inSameSession: boolean;
  analysisMode: AnalysisMode;
  dateRangeId: DateRangeID;
  badClicks: BadClickType[];
  performanceThresholds: number[];
  start: string;
  end: string;
  customEvents: number;
  seenEvents: number;
  ajaxErrors: boolean;
  signals: {
    total: number;
    deadClicks: number;
    rageClicks: number;
    errorClicks: number;
    performance: number;
    customApiEvents: number;
    customDefinedEvents: number;
    seenEvents: number;
    ajaxErrors: number;
  };
}

export const SignalsAnalytics = {
  saveBehaviorSignalSetting: (
    setting: BehaviorSignalElementBlock,
    orgId: string,
    status: boolean,
  ) => {
    FsEvent.recordCustomEventV2('Ignore element from frustration signals', {
      status,
      rageClicks: setting.signals.includes(BehaviorSignalType.SIGNAL_RAGE_CLICK),
      deadClicks: setting.signals.includes(BehaviorSignalType.SIGNAL_DEAD_CLICK),
      descriptionAdded: !isEmpty(setting.notes),
      orgId,
    });
  },
};

type PageType = 'Opportunity Details' | 'Opportunity Snapshot';

export const FindAndFixAnalytics = {
  createSnapshotSuccess: (snapshot: OpportunitySnapshot) => {
    FsEvent.recordCustomEventV2('Create Snapshot Succeeded', {
      ...snapshot,
    });
  },
  createSnapshotError: (request: CreateOpportunitySnapshotRequest, error: any) => {
    FsEvent.recordCustomEventV2('Create Snapshot Failed', {
      ...request,
      error,
    });
  },
  loadSnapshot: (snapshot: OpportunitySnapshot) => {
    FsEvent.recordCustomEventV2('Opportunity Snapshot Loaded', {
      ...snapshot,
    });
  },
  deleteSnapshot: (snapshot: OpportunitySnapshot) => {
    FsEvent.recordCustomEventV2('Opportunity Snapshot Deleted', {
      ...snapshot,
    });
  },
  downloadOpportunity: (opp: OpportunitiesWithID, page: PageType) => {
    FsEvent.recordCustomEventV2('Opportunity Download Clicked', {
      ...opp,
      page,
    });
  },
  matchOpportunityHashes: (
    opportunity: Opportunity,
    segment: Segment | null,
    funnel: Funnel,
    analysisMode: AnalysisMode,
    snapshot: OpportunitySnapshot,
  ) => {
    FsEvent.recordCustomEventV2('Seen Opportunity Detected', {
      opportunity,
      segment,
      funnel,
      analysisMode,
      snapshot,
    });
  },
  shareLink: (page: PageType) => {
    FsEvent.recordCustomEventV2('Opportunity Share Link Clicked', {
      page,
    });
  },
};

export type ImpactsConfigureActionType = 'create' | 'update';

export const RevenueAttributionAnalytics = {
  configureRevenueAttributionSetting: (
    orgId: string,
    revenueEvent: RevenueEventForm,
    createOrUpdate: ImpactsConfigureActionType,
  ) => {
    FsEvent.recordCustomEventV2('Revenue Event Configured', {
      action: createOrUpdate,
      orgId,
      ...revenueEvent,
      currencyString: CurrencyFromCurrencyType[revenueEvent.currency],
    });
  },
  configureRevenueFunnel: (
    orgId: string,
    funnel: Funnel,
    createOrUpdate: ImpactsConfigureActionType,
    funnelId?: string,
  ) => {
    const { name } = funnel;
    FsEvent.recordCustomEventV2('Revenue Funnel Configured', {
      action: createOrUpdate,
      orgId,
      funnelName: name,
      funnelId,
    });
  },
};

export const MutedOpportunitiesAnalytics = {
  muteOpportunity: (status: string, signal: Signal, flags: Flags) => {
    FsEvent.recordCustomEventV2('Mute Conversions Signal', {
      status,
      type: signalTypeName(signal, flags),
    });
  },
};
